import React from 'react';
import { FlameIcon, MessageCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  showReferencePrices: boolean;
  guaranteeEnabled: boolean;
};
const offerItems = ['4 main volumes', '4 free professional bonuses', 'Articulation practice activities', 'Receptive language activities', 'Expressive language activities', 'Social communication activities', 'Minimal pairs therapy cards', 'Speech therapy games & home practice pack', 'Data collection & progress trackers'];
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="offer" className="scroll-mt-2 bg-white px-4 py-6 text-center md:px-12 md:py-7" data-id="element-83" data-mp="2t5t1ctvai70y">
      <p className="font-heading text-[11px] font-bold uppercase tracking-[0.3em] text-goldDark md:text-[12px]" data-id="element-84" data-mp="2y44epeksmznx">
        Special launch offer
      </p>

      <div className="mx-auto mt-1.5 max-w-[512px] rounded-lg border-2 border-gold bg-[#F8FBFD] px-3 pb-3.5 pt-3 md:px-3.5" data-id="element-85" data-mp="12otenehhl7hf">
        <h2 className="font-heading text-[21px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-navy md:text-[27px]" data-id="element-86" data-mp="sxp0ggzmxqnn">
          <MessageCircleIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-gold" strokeWidth={2.5} aria-hidden data-id="element-87" data-mp="owwrzpyl7psf" />
          Complete Speech Therapy Activities Bundle™
        </h2>
        <p className="mx-auto mt-1 max-w-[420px] font-heading text-[11px] font-bold uppercase leading-[1.35] text-brand md:text-[12px]" data-id="element-88" data-mp="1gmrsmirwb1we">
          The complete activity collection for speech-language professionals.
        </p>

        <div className="mx-auto mt-2 max-w-[160px]" data-id="element-89" data-mp="17ltl3qi90c92">
          <ProductImage linkToOffer={false} data-id="element-90" data-mp="16j8woxzd19z" />
        </div>

        <p className="mt-1.5 font-heading text-[12px] font-extrabold uppercase text-navy" data-id="element-91" data-mp="1841wa4ncc5q">Complete 4-in-1 system</p>
        <ul className="mt-1.5 text-left text-[14px] leading-[1.45] text-ink md:text-[15px]" data-id="element-92" data-mp="3sex49hb6ehbu">
          {offerItems.map(item => <CheckItem key={item} data-id="element-93" data-mp="2ngbgd5ixuhz">{item}</CheckItem>)}
        </ul>

        <p className="mt-2.5 flex items-center justify-center gap-1.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[16px]" data-id="element-94" data-mp="2lc5zqrz8nfl">
          <FlameIcon className="h-4 w-4 shrink-0 fill-[#F2913D] text-[#E5622E]" strokeWidth={2} aria-hidden data-id="element-95" data-mp="3otbqyug3mhg9" />
          Get your therapy sessions ready today!
        </p>
        <p className="mt-0.5 font-heading text-[46px] font-extrabold leading-none tracking-[-1px] text-gold md:text-[52px]" data-id="element-96" data-mp="3fuhz1hdpqf91">
          {formatPrice(PRODUCT_PRICE)}
        </p>

        <div className="mt-2" data-id="element-97" data-mp="364eymw49hz0o">
          <CtaButton mode="checkout" subtext="Instant digital access" className="max-w-none min-h-[64px]" data-id="element-98" data-mp="365gkzwqqa7xp">
            Get instant access
          </CtaButton>
        </div>

        <p className="mx-auto mt-2.5 max-w-[400px] font-heading text-[11px] font-bold uppercase leading-snug text-navy md:text-[12px]" data-id="element-99" data-mp="2x3h1mxs8qrrl">
          {guaranteeEnabled && <>
              <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-brand" aria-hidden data-id="element-100" data-mp="28iu7nqpjdlk5" />
              7-day money-back guarantee <span className="text-gold" data-id="element-101" data-mp="2mjoew60ulgh8">•</span>{' '}
            </>}
          <MessageCircleIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-goldDark" aria-hidden data-id="element-102" data-mp="2igibd654e3eg" />
          Complete 4-in-1 system
        </p>
      </div>
    </section>;
}